import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { ReviewDetailContent } from '@/app/donation/gifts/[productNumber]/_components/ReviewDetailContent';
import { Image } from '@/components/client';
import { Rating } from '@/components/molecule/Rating';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
interface WeeklyBestPhotoReviewListItemProps {
  reviewId: number;
  productThumbnailUrl: string;
  productName: string;
  rating: number;
  reviewContent: string;
}
export const WeeklyBestPhotoReviewListItem = t0 => {
  const $ = _c(28);
  const {
    reviewId,
    productThumbnailUrl,
    productName,
    rating,
    reviewContent
  } = t0;
  let t1;
  if ($[0] !== reviewId) {
    t1 = () => {
      openResponsiveDialog({
        component: ReviewDetailContent,
        modalHeader: "\uD3EC\uD1A0\uD6C4\uAE30",
        className: {
          modal: "max-w-[900px]"
        },
        props: {
          reviewId
        },
        drawerNoPadding: true
      });
    };
    $[0] = reviewId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleReviewClick = t1;
  const t2 = `${productName} 후기 상세 보기`;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("group flex w-fit items-center gap-16 rounded-large bg-Gray-white p-16 text-start", "transition-opacity duration-200 ease-out", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500", "active:opacity-80", "mobile-tablet:p-12");
    t4 = cn("relative size-104 shrink-0 overflow-hidden rounded-medium", "mobile-tablet:size-72");
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = `${productName} 이미지`;
  let t6;
  if ($[4] !== productThumbnailUrl || $[5] !== t5) {
    t6 = <Image src={productThumbnailUrl} fill={true} alt={t5} sizes={`${BREAKPOINTS.MOBILE_TABLET} 72px, 104px`} className="object-cover" />;
    $[4] = productThumbnailUrl;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div aria-hidden="true" className="absolute inset-0 bg-Gray-black/0 transition-colors duration-300 ease-out group-hover:bg-Gray-black/5" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <div className={t4}>{t6}{t7}</div>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("flex w-237 flex-col", "mobile-tablet:h-72 mobile-tablet:w-198 mobile-tablet:justify-center");
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== rating) {
    t10 = <Rating value={rating} size={12} />;
    $[11] = rating;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn("line-clamp-1 py-2 font-600 text-Gray-900 transition-colors duration-200 typo-body4", "group-hover:text-Gray-700", "mobile-tablet:font-600 mobile-tablet:typo-caption1");
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== productName) {
    t12 = <p className={t11}>{productName}</p>;
    $[14] = productName;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn("line-clamp-2 pt-4 font-400 text-Gray-600 transition-colors duration-200 typo-body4", "group-hover:text-Gray-700", "mobile-tablet:pt-0 mobile-tablet:font-400 mobile-tablet:typo-caption1");
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== reviewContent) {
    t14 = <span className={t13}>{reviewContent}</span>;
    $[17] = reviewContent;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t10 || $[20] !== t12 || $[21] !== t14) {
    t15 = <div className={t9}>{t10}{t12}{t14}</div>;
    $[19] = t10;
    $[20] = t12;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== handleReviewClick || $[24] !== t15 || $[25] !== t2 || $[26] !== t8) {
    t16 = <li><button onClick={handleReviewClick} aria-label={t2} className={t3}>{t8}{t15}</button></li>;
    $[23] = handleReviewClick;
    $[24] = t15;
    $[25] = t2;
    $[26] = t8;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  return t16;
};